/**
 * 今日到店模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 优惠券详情
Mock.mock(/coupons\/\d+/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'write_off_cashier': true,
    'coupon': {
      'store': {
        'logo': Mock.Random.dataImage('88x88'),
        'image_url': Mock.Random.dataImage('100x100'),
        'name': '@ctitle',
        'address': '@ctitle'
      },
      'plate_number': '粤A@Integer(10000,99999)',
      'status': 'canceled',
      // 'category': /voucher|free|activity|unknown/,
      'title': '天下第一卷',
      'description': '@cparagraph',
      'quote_id|+1': 1,
      'created_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
      'expires_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
      'write_off_at': Mock.Random.datetime('yyyy-MM-dd HH:mm:ss'),
      'face_value': 25554,
      'issue_count|1-100': 1
    }
  },
  'message': 'ok'
})
